import { gql } from "graphql-request";

const SERVER_RESPOND_SURVEY = gql`
  mutation SERVER_RespondSurvey($userSurveyId: ID!, $input: [QuestionAnswerInput]!) {
    respondSurvey(userSurveyId: $userSurveyId, input: $input) {
      id
    }
  }
`;
export default SERVER_RESPOND_SURVEY;